module.exports = __webpack_public_path__ + "img/71.6f340506.webp";